import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "headerMenuId",
  class: "navbar-nav"
}
const _hoisted_2 = { class: "nav-item b-nav-dropdown dropdown show" }
const _hoisted_3 = {
  key: 0,
  tabindex: "-1",
  class: "dropdown-menu show",
  style: {"position":"absolute","top":"-20px","right":"2px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      (_ctx.showMenu)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: "/account",
                onClick: _ctx.toggleLoginMenuIfNoCtrl
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode(" マイページ ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "dropdown-item",
                to: '/' + _ctx.$root.account.info.userName,
                onClick: _ctx.toggleLoginMenuIfNoCtrl
              }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode(" 公開プロフィール ")
                ])),
                _: 1
              }, 8, ["to", "onClick"])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.toggleLoginMenu();_ctx.$root.logoutDialog.open()}),
                type: "button",
                class: "dropdown-item"
              }, " ログアウト ")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}